import { Box, Button, DropdownMenu, Flex, Link, Text, Tooltip } from '@radix-ui/themes';
import Icon from '~/components/Icon';
import StatusIndicator from '~/components/StatusIndicator';
import type { HealthStatusProps, StatuspageStatus } from './types';

const STATUS_TO_COPY_MAPPING = {
  operational: 'Operational',
  degraded_performance: 'Degraded performance',
  partial_outage: 'Partial outage',
  major_outage: 'Major outage',
  under_maintenance: 'Under maintenance',
} as const satisfies Record<StatuspageStatus, string>;

function TooltipContent({ type }: { type: StatuspageStatus }) {
  return <Text size='2'>{STATUS_TO_COPY_MAPPING[type]}</Text>;
}

function HealthStatus({ overall, network, webhooks, api, app }: HealthStatusProps) {
  const individualStatuses = [
    { name: 'Network', type: network },
    { name: 'Webhooks', type: webhooks },
    { name: 'API', type: api },
    { name: 'App', type: app },
  ];

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger>
        <Button
          size='1'
          variant='ghost'
          color='gray'
        >
          <Flex
            gap='2'
            align='center'
          >
            <Box
              width='8px'
              asChild
            >
              <StatusIndicator type={overall} />
            </Box>
            <Text weight='bold'>
              {overall === 'operational' ? 'All systems operational' : STATUS_TO_COPY_MAPPING[overall]}
            </Text>
          </Flex>
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        color='gray'
        size='2'
        variant='soft'
      >
        {individualStatuses.map(item => {
          return (
            <Tooltip
              content={<TooltipContent type={item.type} />}
              key={item.name}
              side='right'
            >
              <DropdownMenu.Item>
                <Flex
                  justify='between'
                  width='128px'
                >
                  <Box>{item.name}</Box>
                  <Box>
                    <StatusIndicator type={item.type} />
                  </Box>
                </Flex>
              </DropdownMenu.Item>
            </Tooltip>
          );
        })}
        <DropdownMenu.Separator />
        <DropdownMenu.Item asChild>
          <Link
            href='https://status.onomondo.com'
            weight='regular'
            target='_blank'
            color='gray'
            highContrast
            underline='none'
          >
            <Flex
              justify='between'
              width='100%'
            >
              <Box>
                <Text highContrast>Status Page</Text>
              </Box>
              <Box>
                <Icon
                  name='external-link'
                  width={16}
                  height={16}
                />
              </Box>
            </Flex>
          </Link>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}

export default HealthStatus;
